import { handleVersionMismatch } from 'actions/versionSync';
import { FETCH_INTERACTIONS_SUCCESS } from 'actiontypes/messages';
import { VersionMismatch } from 'services/BaseService';
import MessagesService from 'services/MessagesService';
import { INTERACTIONS, fetchRequested } from './fetch';
import { IMessagesService } from 'types/messages';

export const fetchInteractionsSuccess = (data: any) => ({
  type: FETCH_INTERACTIONS_SUCCESS,
  payload: data,
});

export default fetchInteractions(new MessagesService());

export function fetchInteractions(service: IMessagesService) {
  return () => async (dispatch: Function) => {
    dispatch(fetchRequested(INTERACTIONS));
    try {
      const { data } = await service.fetch('interactions');
      dispatch(fetchInteractionsSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      throw error;
    }
  };
}